export default __webpack_public_path__ + "static/media/monkey-10.9baccc2a.png";